import React from 'react';
import { Typography, Container, Grid, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { AboutSection, StyledAvatar, ContentWrapper } from '../styles/AboutMeStyles';
import { useAboutMe } from '../utils/AboutMeUtils';

const AboutMeComp = () => {
  const theme = useTheme();
  const { avatarAlt, avatarSrc, title, paragraphs } = useAboutMe();

  return (
    <AboutSection>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={4}>
            <Box display="flex" justifyContent="center">
              <StyledAvatar alt={avatarAlt} src={avatarSrc} />
            </Box>
          </Grid>
          <Grid item xs={12} md={8}>
            <ContentWrapper>
              <Typography variant="h3" gutterBottom sx={{ 
                fontWeight: 'bold', 
                color: theme.palette.mode === 'dark' ? '#BB86FC' : theme.palette.primary.main,
                marginBottom: 3,
                textShadow: theme.palette.mode === 'dark' ? '2px 2px 4px rgba(0,0,0,0.5)' : 'none',
              }}>
                {title}
              </Typography>
              {paragraphs.map((text, idx) => (
                <Typography
                  key={idx}
                  variant="body1"
                  paragraph={idx < paragraphs.length - 1}
                  sx={{
                    fontSize: '1.1rem',
                    lineHeight: 1.6,
                    color: theme.palette.mode === 'dark' ? '#E0E0E0' : 'inherit',
                  }}
                >
                  {text}
                </Typography>
              ))}
            </ContentWrapper>
          </Grid>
        </Grid>
      </Container>
    </AboutSection>
  );
};

export default AboutMeComp;
